import Udesk from 'Udesk';
import React, { FC, memo, useMemo } from 'react';
import { usePageParams } from '../../hooks';
import NestHome from 'Component/common/nest-home-with-subnav';
import { getCurrentRouteName } from 'Udesk/system/subApp';
import UdeskLocales from 'UdeskLocales';

interface TemplateProps {
    match?: any;
    history?: any;
}

const Template: FC<TemplateProps> = memo((props) => {
    const { history } = props;

    const { id } = usePageParams(props);

    const onBack = () => {
        Udesk.ui.routing.transitionTo({
            history,
            routeName: getCurrentRouteName('productManage'),
        });
    };

    const navLists = useMemo(
        () => [
            {
                text: /* 语音通话 */ UdeskLocales['current'].pages.conversationAnalysis
                    .productManage.components.acousticData.index.voiceCall,
                key: 'voice',
                pathName: getCurrentRouteName('productManageDetailAcousticDataVoice'),
                pathParams: { id },
            },
            {
                text: /* 文本对话 */ UdeskLocales['current'].pages.conversationAnalysis
                    .productManage.components.acousticData.index.textDialogue,
                key: 'text',
                pathName: getCurrentRouteName('productManageDetailAcousticDataText'),
                pathParams: { id },
            },
            {
                text: /* 工单 */ UdeskLocales['current'].pages.conversationAnalysis.productManage
                    .components.acousticData.index.workOrder,
                key: 'ticket',
                pathName: getCurrentRouteName('productManageDetailAcousticDataTicket'),
                pathParams: { id },
            },
            {
                text: /* 问卷 */ UdeskLocales['current'].pages.conversationAnalysis.productManage
                    .components.acousticData.index.questionnaire,
                key: 'survey',
                pathName: getCurrentRouteName('productManageDetailAcousticDataSurvey'),
                pathParams: { id },
            },
            {
                text: /* 视频通话 */ UdeskLocales['current'].pages.conversationAnalysis
                    .productManage.components.acousticData.index.videoCall,
                key: 'video',
                pathName: getCurrentRouteName('productManageDetailAcousticDataVideo'),
                pathParams: { id },
            },
            {
                text: /* 企微数据 */ UdeskLocales['current'].pages.conversationAnalysis
                    .productManage.components.acousticData.index.enterpriseMicroData,
                key: 'wecom',
                pathName: getCurrentRouteName('productManageDetailAcousticDataWecom'),
                pathParams: { id },
            },
            {
                text: /* 社媒评论 */ UdeskLocales['current'].pages.conversationAnalysis
                    .productManage.components.acousticData.index.socialMediaComments,
                key: 'media',
                pathName: getCurrentRouteName('productManageDetailAcousticDataMedia'),
                pathParams: { id },
            },
            {
                text: /* 应用评论 */ UdeskLocales['current'].pages.conversationAnalysis
                    .productManage.components.acousticData.index.applicationComments,
                key: 'application',
                pathName: getCurrentRouteName('productManageDetailAcousticDataApplication'),
                pathParams: { id },
            },
        ],
        [id]
    );

    return (
        <NestHome
            {...props}
            navLists={navLists}
            onBack={onBack}
            isTabs
            menuTitle={
                /* 关联原声数据 */ UdeskLocales['current'].pages.conversationAnalysis.productManage
                    .components.acousticData.index.associatesAcousticData
            }
        />
    );
});

export default Template;
